import { Flex } from "@radix-ui/themes";

export default function GhostCard({ children }: { children: React.ReactNode }) {
  return (
    <Flex
      direction="column"
      className="h-[220px] lg:h-[280px] w-full min-w-0 items-center justify-center rounded-lg border border-dashed border-blue-900/20 p-10"
    >
      <span className="text-[#5D7895]/10">{children}</span>
    </Flex>
  );
}
